module.exports = new __parcel__URL__("lemon.7d7dfe19.svg").toString();